import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface OTChecklistParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface OTChecklist { 

    id?:number;
    name?:string;
    branchId: string;
    tenantId: string;  
   
    parameters?: OTChecklistParameter[];
    links?: any;
}


export abstract class OTChecklistData {
    abstract list(url: string): Observable<any>; 
    abstract getById(url: string): Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract getall(url: string): Observable<OTChecklist[]>;
    abstract create(url: string, data: OTChecklist): Observable<OTChecklist[]>;
    abstract update(url: string, data: OTChecklist): Observable<OTChecklist>;
}
